<div class="row settings d-md-flex">
    <aside class="p-3">
        <mat-select class="form-select" [formControl]="brandingCtrl">
            @for (branding of brandings; track branding) {
                <mat-option [value]="branding">{{ branding }}</mat-option>
            }
        </mat-select>
        <ul class="nav nav-pills nav-stacked">
            @for(template of templates; track template.label){
                <li class="nav-item w-100 mb-3" role="presentation">
                    <a class="nav-link" (click)="renderEmail(template.url, template.options)" >{{ template.label }}</a>
                </li>
            }
        </ul>
    </aside>

    <div class="p-0 mx-0 setup-content">
        <div class="container pt-5 admin">
            @if(options?.length > 0){
                <mat-select class="form-select">
                    @for (option of options; track option) {
                        <mat-option [value]="option" (click)="setOption(option)">{{ option }}</mat-option>
                    }
                </mat-select>
                <hr/>
            }
            <div class="col-md-9 shadow-lg p-3 mb-5 bg-body rounded" [innerHTML]="html"></div>
        </div>
    </div>
</div>


